<script setup lang="ts">
import type { NuxtError } from "#app";
definePageMeta({
  allowAnonymous: true,
});
const { t } = useI18n();
const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => null,
  },
});
/**
 * Fix for related issue: https://github.com/nuxt/nuxt/issues/34579
 */
setTimeout(() => {
  const activeHead = useHead({
    title: `${props.error?.statusCode}  -  ${t("errors.pages.404.title")}`,
  });

  const head = useLocaleHead({ dir: true, seo: true, lang: true });
  activeHead.patch({
    htmlAttrs: {
      lang: head.value.htmlAttrs?.lang ?? "en",
      dir: <"ltr" | "rtl">head.value.htmlAttrs?.dir ?? "ltr",
      style: `--direction: ${head.value.htmlAttrs?.dir ?? "ltr"};`,
    },
    title: `${props.error?.statusCode}  -  ${t("errors.pages.404.title")}`,
  });
}, 0);
</script>

<template>
  <NuxtLayout name="error">
    <slot />
  </NuxtLayout>
</template>
